import React, { createContext, useContext } from 'react';

import { DirectTreasuryOfferEntityNormalized } from '../../../../../../../store/product/types';

interface DirectTreasuryAssetContextReceivedData {}

interface DirectTreasuryAssetContextData extends DirectTreasuryAssetContextReceivedData {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  offerSelected: DirectTreasuryOfferEntityNormalized | undefined;
  setOfferSelected: React.Dispatch<
    React.SetStateAction<DirectTreasuryOfferEntityNormalized | undefined>
  >;
}

interface Props extends DirectTreasuryAssetContextReceivedData {
  children: React.ReactNode;
}

const DirectTreasuryAssetContext = createContext<DirectTreasuryAssetContextData>(
  {} as DirectTreasuryAssetContextData
);

const DirectTreasuryAssetProvider: React.FC<Props> = ({ children, ...props }) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [offerSelected, setOfferSelected] = React.useState<DirectTreasuryOfferEntityNormalized>();

  return (
    <DirectTreasuryAssetContext.Provider
      value={{
        ...props,
        modalOpen,
        setModalOpen,
        offerSelected,
        setOfferSelected,
      }}>
      {children}
    </DirectTreasuryAssetContext.Provider>
  );
};

const useDirectTreasuryAssetContext = (): DirectTreasuryAssetContextData => {
  const context = useContext(DirectTreasuryAssetContext);

  if (!context) {
    throw new Error(
      'useDirectTreasuryAssetContext must be used within an DirectTreasuryAssetContext'
    );
  }
  return context;
};

export {
  DirectTreasuryAssetProvider,
  useDirectTreasuryAssetContext,
  DirectTreasuryAssetContextData,
};
